import Cookies from 'js-cookie';
import { useState } from 'react';

// eslint-disable-next-line import/no-cycle
import LoginModal from 'profile/login/LoginModal';

const LoginToPurchase = (props) => {
  const [modal, setModal] = useState(null);

  const handleLogin = () => {
    setModal('Login');
  };

  const { product } = props;
  if (Cookies.get('customerToken')) {
    return (
      <div className="c7-product__login-message">
        <LoggedInMessage product={product} />
      </div>
    );
  }
  return (
    <>
      <div className="c7-product__login-message">
        <NotLoggedInMessage product={product} />
        <button type="button" onClick={handleLogin}>
          Login
        </button>
      </div>
      <LoginModal modal={modal} setModal={setModal} />
    </>
  );
};

const NotLoggedInMessage = (props) => {
  const { product } = props;
  switch (product.security.availableTo) {
    case 'Allocation':
      return (
        <p>
          This product is for customers who are participating in our allocation
          program. Please login to purchase.
        </p>
      );
    case 'Club': {
      return (
        <p>This product is for club members only. Please login to purchase.</p>
      );
    }
    case 'Tag': {
      return (
        <p>
          This product is for select customers only. Please login to purchase.
        </p>
      );
    }
    case 'Loyalty Tier': {
      return (
        <p>
          This product is for loyalty members only. Please login to purchase.
        </p>
      );
    }
    default: {
      return <p>This is a secure product. Please login to purchase.</p>;
    }
  }
};

const LoggedInMessage = (props) => {
  const { product } = props;
  switch (product.security.availableTo) {
    case 'Allocation':
      return (
        <p>
          This product is for customers who are participating in a different
          allocation program than the one you are currently in.
        </p>
      );
    case 'Club': {
      return (
        <p>
          This product is for customers who are club members. Please signup to
          purchase.
        </p>
      );
    }
    case 'Tag': {
      return <p>This product is for select customers only.</p>;
    }
    case 'Loyalty Tier': {
      return <p>This product is for certain levels of Loyalty only.</p>;
    }
    default: {
      return <p>this is a secure product</p>;
    }
  }
};

export default LoginToPurchase;
